import React, { useState, useEffect } from "react";
import { Row, Col, Card, DatePicker, Radio, message, Typography, Space } from "antd";
import moment from "moment";
import Echart from "./../chart/EChart";
import LineChart from "./../chart/LineChart";
import {
  get_user_according_to_date_rangeApi,
  get_new_users_according_to_date_range,
} from "../../api/admin.apis";

const { RangePicker } = DatePicker;
const { Title } = Typography;

export const ChartsSection = () => {
  const [activeUsersByDate, setActiveUsersByDate] = useState([]);
  const [newUsersByDate, setNewUsersByDate] = useState([]);
  const [loading, setLoading] = useState(false);
  const [viewType, setViewType] = useState("daily");
  const [dateRange, setDateRange] = useState([
    moment().subtract(7, "days"),
    moment(),
  ]);

  useEffect(() => {
    fetchAllData(dateRange[0], dateRange[1]);
  }, [dateRange, viewType]);

  const fetchAllData = async (start, end) => {
    try {
      setLoading(true);
      const startDate = moment(start).format("YYYY-MM-DD");
      const endDate = moment(end).format("YYYY-MM-DD");

      const [activeRes, newRes] = await Promise.all([
        get_user_according_to_date_rangeApi(startDate, endDate),
        get_new_users_according_to_date_range(startDate, endDate),
      ]);

      // ----- Active Users -----
      if (activeRes.data.status === "success") {
        let chartData = activeRes.data.data;

        if (viewType === "monthly") {
          const monthlyData = {};
          chartData.forEach((item) => {
            const month = moment(item.date).format("MMM YYYY");
            monthlyData[month] =
              (monthlyData[month] || 0) + item.unique_active_users;
          });
          chartData = Object.entries(monthlyData).map(([date, users]) => ({
            date,
            users,
          }));
        } else {
          chartData = chartData.map((item) => ({
            date: item.date,
            users: item.unique_active_users,
          }));
        }

        setActiveUsersByDate(chartData);
      } else {
        message.error("Failed to fetch active users data");
      }

      // ----- New Users -----
      if (newRes.data.status === "success") {
        let chartData = newRes.data.data;

        if (viewType === "monthly") {
          const monthlyData = {};
          chartData.forEach((item) => {
            const month = moment(item.date).format("MMM YYYY");
            monthlyData[month] =
              (monthlyData[month] || 0) + item.new_users_count;
          });
          chartData = Object.entries(monthlyData).map(([date, users]) => ({
            date,
            new_users_count: users,
          }));
        }

        setNewUsersByDate(chartData);
      } else {
        message.error("Failed to fetch new users data");
      }
    } catch (err) {
      console.error("Error fetching chart data:", err);
      message.error("Error fetching chart data");
    } finally {
      setLoading(false);
    }
  };

  const onDateChange = (dates) => {
    if (dates) setDateRange(dates);
  };

  const onViewTypeChange = (e) => {
    setViewType(e.target.value);
  };

  return (
    <Row gutter={[24, 24]}>
      <Col xs={24} md={12}>
        <Card
          bordered={false}
          title={
            <Space direction="vertical" style={{ width: "100%" }}>
              <Row justify="space-between" align="middle">
                <Col>
                  <Title level={5}>Active Users</Title>
                </Col>
                <Col>
                  <Space>
                    <RangePicker
                      size="small"
                      value={dateRange}
                      onChange={onDateChange}
                      format="YYYY-MM-DD"
                    />
                    <Radio.Group
                      size="small"
                      value={viewType}
                      onChange={onViewTypeChange}
                      options={[
                        { label: "Daily", value: "daily" },
                        { label: "Monthly", value: "monthly" },
                      ]}
                      optionType="button"
                    />
                  </Space>
                </Col>
              </Row>
            </Space>
          }
        >
          <Echart activeUsersByDate={activeUsersByDate} loading={loading} />
        </Card>
      </Col>

      <Col xs={24} md={12}>
        <Card bordered={false}>
          <LineChart
            activeUsersByDate={activeUsersByDate}
            newUsersByDate={newUsersByDate}
            loading={loading}
            dateRange={dateRange}
            viewType={viewType}
          />
        </Card>
      </Col>
    </Row>
  );
};
